// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill'//ie浏览器兼容的问题
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import rtbook from '@/components/RtBook'
import rtshare from '@/components/RtShare'
import VDistpicker from 'v-distpicker'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

Vue.component('v-distpicker', VDistpicker);
Vue.use(VueAwesomeSwiper);

import clipBoard from 'vue-clipboard2'
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true ;//复制粘贴插件
Vue.use(VueClipboard);
Vue.use(clipBoard);

Vue.use(ElementUI);
Vue.component('rt_book', rtbook);
Vue.component('rt_share', rtshare);

import axios from 'axios'
//引入store
import store from "./vuex";
// const store = require('./vuex')



import {Decrypt,Encrypt} from './assets/js/utils.js'

// axios.defaults.headers.common['Token'] = localStorage.token;
// 添加请求拦截器

axios.interceptors.request.use(config => {
// 在发送请求之前做些什么
//判断是否存在token，如果存在将每个页面header都添加token
  if(config.url.indexOf('qq/oauth2.0')===-1&&config.url.indexOf('weixin/sns/oauth2')===-1){
    if(config.url !== '/api/user_action/uploadAvatar'){
      // config.data= config.data!==''?{encryption:Encrypt(JSON.stringify(config.data))}: {encryption:1}
    }
  }
  // if(localStorage.token){
  //   config.headers.common['Token']=localStorage.token
  // }
  config.headers.common['Token']=localStorage.getItem('token')
  return config;
}, error => {
// 对请求错误做些什么
  return Promise.reject(error);
});


// http response 拦截器
axios.interceptors.response.use(

  response => {
    if(response.config.url.indexOf('qq/oauth2.0')===-1&&response.config.url.indexOf('weixin/sns/oauth2')===-1){
      if(response.config.url !=='/api/user_action/uploadAvatar'){
        // response.data = JSON.parse(Decrypt(response.data))
      }
    }
    if(response.data.ret===401){
      store.commit('set_userinfo',{});
      localStorage.token=''
      // localStorage.clear()
      router.replace({
        path: '/login',
        // query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
      })
    }

    return response;
  },
  error => {

    if (error.response) {

      switch (error.response.data.ret) {
        case 401:
          this.$store.commit('del_token');
      }
    }
    return Promise.reject(error.response.data)
  });



Vue.prototype.$http  = axios;//定义成对象方便调用
Vue.prototype.$EventBus = new Vue()

import animate from 'animate.css'//引入动画效果
Vue.use(animate)

import VueWechatTitle from 'vue-wechat-title'//网页标题
Vue.use(VueWechatTitle)

// 新增加的jquery.min和boostrap的css、js
import 'jquery/dist/jquery.min'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import './assets/css/common.css'//公共的css
import './assets/css/mainCss.css'//公共的css

import './assets/js/jquery.SuperSlide.2.1.1'



import header_nav from "@/components/header_nav";//导航部分
import foot from "@/components/foot";//底部部分
import about_sidebar from "@/components/about_sidebar";//about_sidebar关于侧边栏
import about_sidebar1 from "@/components/about_sidebar1";//about_sidebar关于侧边栏
import about_sidebar2 from "@/components/about_sidebar2";//about_sidebar关于侧边栏
import about_sidebar3 from "@/components/about_sidebar3";//about_sidebar关于侧边栏
import my_sidebar from "@/components/my_sidebar";//my_sidebar我的资料作品
import Pagination from 'vue-pagination-2';//分页插件
Vue.component('header_nav', header_nav)//导航
Vue.component('foot',foot)//底部
Vue.component('about_sidebar',about_sidebar)//about_sidebar关于侧边栏
Vue.component('about_sidebar1',about_sidebar1)//about_sidebar关于侧边栏
Vue.component('about_sidebar2',about_sidebar2)//about_sidebar关于侧边栏
Vue.component('about_sidebar3',about_sidebar3)//about_sidebar关于侧边栏
Vue.component('my_sidebar',my_sidebar)//my_sidebar我的资料作品
Vue.component('pagination', Pagination)//分页插件


//验证组件
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js